import {Component, Inject, OnInit} from "@angular/core";
import {DomSanitizer, SafeHtml, SafeUrl} from "@angular/platform-browser";
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import {TransactionInput} from "../../../modules/models/types";
import {ErrorMessageService} from "../../../modules/helpers/error-message.service";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-transaction-dialog",
  templateUrl: "./transaction-dialog.component.html",
  styleUrls: ["./transaction-dialog.component.css"]
})
export class TransactionDialogComponent implements OnInit {
  private height: number;
  constructor(public dialogRef: MatDialogRef<TransactionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public dialog_data: TransactionInput,
              private error_message_service: ErrorMessageService,private http : HttpClient) {
                this.http = http;
    this.height = 0;
    this.retryCodes = [401, 402, 403, 500, 501, 604];
  }

  
  public hand: SafeUrl;
  public closeButtonlabel = "Close";
  public retryButtonLabel = "Retry";

  public showRetry: boolean;
  public showIcon: string;

  public description: SafeHtml;
  public retryCodes: any;

  public eyeVsibility: any;
  public eyeStatus: any;
  public eyeOpenness: any;
  public blur: any;
  public aligned: string;
  public occlusion: boolean;
  public occlusion_score: boolean;
  public icao: any;
  
  ngOnInit() {
    const code = this.dialog_data.data.code;
    this.showRetry = this.retryCodes.indexOf(code) !== -1;
    this.showIcon = "user";
    if (code.toString() === "200") {
      this.showIcon = "success";
      this.aligned = this.dialog_data.image
    } else if (code.toString() === "500") {
      this.showIcon = "error";
    }

    if (!this.showRetry) {
      this.closeButtonlabel = "Close";
    }
    let message = this.error_message_service.getErrorString(this.dialog_data.data.feedback_code.toString());
    if (code === 200 && this.dialog_data?.data?.quality) {
      if (this.dialog_data.data.quality.eyes_status != void 0 && this.dialog_data.data.quality.eyes_open_metric != void 0 ) {
        this.eyeVsibility = this.dialog_data.data.quality.eye_visibility;
        this.eyeStatus = this.dialog_data.data.quality.eyes_status;
        this.eyeOpenness = this.dialog_data.data.quality.eyes_open_metric.toFixed(2);
      }
      this.blur = this.dialog_data.data.quality.quality_metric.toFixed(2);
      this.occlusion = this.dialog_data.data.quality.face_occlusions_check;
      this.occlusion_score = this.dialog_data.data.quality.face_occlusions_check_score;
      this.icao = this.dialog_data.data.icao;
    }
    this.description = message;
  }

  onCloseClicked() {
  const allowPost = (window as any).allow_post;

    if(allowPost=="true"){
    this.http.post("http://localhost:3001/createfile", this.dialog_data.jsonresponse).subscribe();
    }
    if (this.dialog_data.onclose) {
      this.dialog_data.onclose();
    }
  }

  onRetryClicked() {
    if (this.dialog_data.onretry) {
      this.dialog_data.onretry();
    }
    this.dialogRef.close();
  }
}


